import Immutable from 'immutable';

const ActivityEntryModel = Immutable.Record({
	kind: '',        // 'comment' | 'history' | 'ticket'
	id: 0,           // comment/history: the row id. ticket: the helpdesk ticket number.
	date: 0,         // unix seconds
	userId: 0,
	userEmail: '',   // live email of the author, or a creation-time snapshot for deleted users
	type: '',        // subject entity: 'device' | 'geofence'
	objectId: 0,     // id of that subject
	text: '',        // comment only
	topic: '',       // history only, e.g. 'name'
	oldValue: null,  // history only
	newValue: null,  // history only
	labelId: null,   // 'labelAdded'/'labelRemoved' topics only
	labelName: '',   // name as of the event, not the label's current name
	ticketSubject: '' // ticket only: the helpdesk ticket's subject line
});

export default class ActivityEntry extends ActivityEntryModel {
	kind: string;
	id: number;
	date: number;
	userId: number;
	userEmail: string;
	type: string;
	objectId: number;
	text: string;
	topic: string;
	oldValue: ?string;
	newValue: ?string;
	labelId: ?number;
	labelName: string;
	ticketSubject: string;

	constructor(data = {}) {
		// The API serializes DateTime as a unix-seconds string; coerce to a number for dayjs.unix().
		super({...data, date: +data.date || 0});
	}

	get isComment() {
		return this.kind === 'comment';
	}

	get isHistory() {
		return this.kind === 'history';
	}

	// A helpdesk ticket being opened or closed. It carries no old/new value pair — the moment itself
	// is the content, and the entry's date is when it happened.
	get isTicket() {
		return this.kind === 'ticket';
	}

	// Ticket entries address their ticket by its helpdesk number, which is the entry's own id.
	get ticketNumber() {
		return this.id;
	}

	// Label association changes are history entries, but they carry a label snapshot instead of an
	// old/new value pair, so the feed renders them as a chip rather than 'old -> new'.
	get isLabelChange() {
		return this.topic === 'labelAdded' || this.topic === 'labelRemoved';
	}
}
